define([
	"dojo/_base/declare",
	"csi",
	"csi/_base/underscore",
	"./TwoDimSizesContainerMixin"
], function(declare,csi,_,TwoDimSizesContainerMixin) {

	return  declare(TwoDimSizesContainerMixin, {
		// Object to support Increment with 2D sizes.

		constructor: function(/*Cache*/cache, /*Node*/incrementNode) {
			this.node = incrementNode;
			this.sizes = cache.getNodes(incrementNode.Sizes);
			this.baseIndex = incrementNode.BaseSizeIndex;

			// For 2-d support
			this._isTwoDim = !_.isEmpty(incrementNode.IncrementDimension2Sizes);
			if (!this._isTwoDim)
				return;

			var baseSizeProductSize = cache.getNode(cache.getNode(incrementNode.BaseSize).IncrementSize);
			this.baseSizeDim1Index = _.indexOf(this.node.IncrementDimension1Sizes, baseSizeProductSize.Dimension1Size);
			this.baseSizeDim2Index = _.indexOf(this.node.IncrementDimension2Sizes, baseSizeProductSize.Dimension2Size);

			this.dim1Sizes = this.node.IncrementDimension1Sizes;
			this.dim2Sizes = this.node.IncrementDimension2Sizes;

			// add {Dime1Size, Dim2Size} indices to map
			var obj = this._mapIncrementIndexToDimSizesIndices = {};
			var dim1Map = csi.hashArray(incrementNode.IncrementDimension1Sizes, null, Number);
			var dim2Map = csi.hashArray(incrementNode.IncrementDimension2Sizes, null, Number);

			var iSize = 0;
			for (var iSize = 0; iSize < this.sizes.length; ++iSize) {
				var curProdSize = cache.getNode(this.sizes[iSize].IncrementSize);
				obj[iSize] = {
					dim1SizeIndex: dim1Map[curProdSize.Dimension1Size],
					dim2SizeIndex: dim2Map[curProdSize.Dimension2Size]
				};
			}

			// map {dim1SizeIndex, {dim2SizeIndex, vectorIndex})
			var obj2 = {};
			var iDim1 = 0;
			var dim2ToVector;
			for (iDim1 = 0; iDim1 < this.getDim1SizeCount(); ++iDim1) {
				dim2ToVector = {};
				for (iSize = 0; iSize < this.sizes.length; ++iSize) {
					var curDim1Dim2 = this._mapIncrementIndexToDimSizesIndices[iSize];
					if (curDim1Dim2.dim1SizeIndex == iDim1) {
						dim2ToVector[curDim1Dim2.dim2SizeIndex] = iSize;
					}
				}
				obj2[iDim1] = dim2ToVector;
			}
			this._mapDim1ToDim2Indices = obj2;
		},

		incrementToAbsolute: function(/*Double[]*/inc, /*Boolean*/displayTwoDim) {
			// summary: convert the double vector from increment mode to absolute mode
			var	abs = [].concat(inc);

			var baseFunc = function(x) {
				abs[x] = inc[x];
			};

			if (displayTwoDim) {
				this.iterate2D(
					baseFunc,
					function(x, y) {
						var index = this._mapDim1ToDim2Indices[x][y];
						if (index == undefined || index < 0) // 2D SizeRange with hole(s)
							return;

						abs[index] = abs[this.getCompareIndex(index)] + inc[index];
					}
				);
			} else {
				this.iterate1D(
					baseFunc,
					function(x) {
						abs[x] = abs[x+1] + inc[x];
					},
					function(x) {
						abs[x] = abs[x-1] + inc[x];
					}
				);
			}

			return abs;
		}

	});

});
